angular
    .module('dnecom.component.cart', ['ngCookies'])
    .config(["$httpProvider", function($httpProvider) {
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    }]);